import axios from "axios";
import axiosInstance from "../../../../../../Utils/axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const grnURL = `api/v1/purchase-app/grn`;
//obtaining the paginated data
export const getGrn = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${grnURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllGrn = () => axiosInstance.get(`${grnURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageGrn = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${grnURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getPurchaseOrderAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);
//get by id
export const getPurchaseOrderDetailsById = (id) =>
  axiosInstance.get(`api/v1/purchase-app/purchase-order/retrieve/${id}`);
//get by id
export const getGrnById = (id) => axiosInstance.get(`${grnURL}/retrieve/${id}`);
// api/v1/purchase-app/grn/retrieve
//creating function
export const createGrn = (body) => axiosInstance.post(`${grnURL}/create`, body);
//updating function
export const updateGrn = (id, body) => axiosInstance.patch(`${grnURL}/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${grnURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataGrnName = (e, cancelToken) =>
  axiosInstance.get(`${grnURL}?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
